module.exports = __webpack_public_path__ + "img/anticlockwise.99b74951.png";